"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var InputMask = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(InputMask, _Vue);
  var _super = (0, _createSuper2.default)(InputMask);
  function InputMask() {
    var _this;
    (0, _classCallCheck2.default)(this, InputMask);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "value", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isFocus", false);
    return _this;
  }
  (0, _createClass2.default)(InputMask, [{
    key: "handleBlur",
    value: function handleBlur() {
      this.isFocus = false;
      this.$emit("blur");
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.isFocus = true;
      this.$emit("focus");
    }
  }, {
    key: "handleInput",
    value: function handleInput(ev) {
      this.$emit("input", ev.currentTarget.value);
    }
  }]);
  return InputMask;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], InputMask.prototype, "value", void 0);
InputMask = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], InputMask);
var _default = InputMask;
exports.default = _default;